import CloseButton from 'src/components/CloseButton'
import { cn } from 'src/utils'

export type ModalProps = {
  visible: boolean
  onClose: () => void
}

const Modal = ({
  visible,
  children,
  className,
  onClose,
}: React.PropsWithChildren<ModalProps> &
  JSX.IntrinsicElements['div']) => (
  <div
    className={cn(
      `fixed left-1/2 top-1/2 flex h-[calc(100vh-2rem)] max-h-full w-[calc(100vw-2rem)] max-w-full flex-grow -translate-x-1/2 -translate-y-1/2 flex-col gap-4 overflow-y-auto rounded-lg bg-white py-12 px-4 shadow-md ring-2 ring-slate-900/5 md:top-[calc(50%+2rem)]  md:max-h-[45rem] md:max-w-sm`,

      !visible ? '-z-50 opacity-0' : 'z-50',
      className,
    )}
  >
    {children}
    <CloseButton
      onClick={onClose}
      className="bg-red absolute right-2 top-2"
    />
  </div>
)

export default Modal
